import { z } from "zod";
import { createCommonApiResponseSchema } from "@/server/agentTypes";

const SETTINGS_ITEM_OPTIONS = [
  z.object({ code: z.literal("DisclosedConsentsList"), value: z.boolean() }),
  z.object({ code: z.literal("TextMotivationEsia2"), value: z.string() }),
  z.object({ code: z.literal("ApplicationPendingTime"), value: z.number() }),
  z.object({ code: z.literal("ChangePhoneLinkVisible"), value: z.boolean() }),
  z.object({
    code: z.literal("DefaultSumAdditionalIncome"),
    value: z.number(),
  }),
  z.object({ code: z.literal("ManualDownloadFilesNewLK"), value: z.string() }),
  z.object({
    code: z.literal("CreditLimitTranshShortText"),
    value: z.string(),
  }),
  z.object({ code: z.literal("TextMotivationEsia1"), value: z.string() }),
  z.object({ code: z.literal("NewLkFinProtectText"), value: z.string() }),
  z.object({ code: z.literal("CreditRateResultWaitTime"), value: z.number() }),
  z.object({
    code: z.literal("ShowPTIAdditionalIncomeNewClient"),
    value: z.boolean(),
  }),
  z.object({ code: z.literal("TextMotivationEsia3"), value: z.string() }),
  z.object({ code: z.literal("RndSmev4WaitTimeoutSec"), value: z.number() }),
  z.object({ code: z.literal("AccessTokenLifeTime"), value: z.number() }),
  z.object({ code: z.literal("OfferSumChanged"), value: z.string() }),
  z.object({
    code: z.literal("ChangePhoneDirectAccessRestricted"),
    value: z.boolean(),
  }),
  z.object({ code: z.literal("NalogRuWaitTimeoutSec"), value: z.number() }),
  z.object({ code: z.literal("PTICalculationSource"), value: z.string() }),
  z.object({
    code: z.literal("EsiaDataUpdateAnnotationText"),
    value: z.string(),
  }),
  z.object({
    code: z.literal("CreditLimitTranshShortTextAutoprolong"),
    value: z.string(),
  }),
  z.object({ code: z.literal("RndSmev4Group"), value: z.number() }),
  z.object({ code: z.literal("HeaderTextNewLK"), value: z.string() }),
  z.object({ code: z.literal("ProlongationDebtHint"), value: z.string() }),
  z.object({ code: z.literal("IsTwoSumSignEnabled"), value: z.boolean() }),
  z.object({
    code: z.literal("Text_agreement_use_service"),
    value: z.string(),
  }),
  z.object({ code: z.literal("ClueChangePhonePassport"), value: z.string() }),
  z.object({ code: z.literal("BINCardCheckErrorText"), value: z.string() }),
  z.object({ code: z.literal("UsePrescoringSumMin"), value: z.boolean() }),
  z.object({ code: z.literal("RefreshTokenLifeTime"), value: z.number() }),
  z.object({
    code: z.literal("DeemFraudulentReportEmailSendingList"),
    value: z.string(),
  }),
  z.object({ code: z.literal("ShowInnApplicationStep"), value: z.boolean() }),
  z.object({ code: z.literal("ScansToUploadWaitingTime"), value: z.number() }),
  z.object({
    code: z.literal("DefaultSumAdditionalIncomeNewClient"),
    value: z.number(),
  }),
  z.object({
    code: z.literal("MinSumOnBankCardForLinkingShowMessage"),
    value: z.boolean(),
  }),
  z.object({
    code: z.literal("IsRequiredCreditHistoryCheckbox"),
    value: z.boolean(),
  }),
  z.object({ code: z.literal("EsiaRegistrationFailure"), value: z.string() }),
  z.object({ code: z.literal("InnStepFirstText"), value: z.string() }),
  z.object({ code: z.literal("DefaultZip"), value: z.string() }),
  z.object({ code: z.literal("ApplicationCodeMask"), value: z.string() }),
  z.object({
    code: z.literal("GetSumAdditionalIncomeFromDWHQuery"),
    value: z.string(),
  }),
  z.object({ code: z.literal("RequiredScanSum"), value: z.number() }),
  z.object({ code: z.literal("InnStepSecondText"), value: z.string() }),
  z.object({ code: z.literal("ShowExpenses"), value: z.boolean() }),
  z.object({ code: z.literal("HidePassportIssuedBy"), value: z.boolean() }),
  z.object({
    code: z.literal("TextPTIAdditionalIncomeNewClient"),
    value: z.string(),
  }),
  z.object({
    code: z.literal("StatusesDuringForClientDenial"),
    value: z.string(),
  }),
  z.object({
    code: z.literal("MinSumOnBankCardForLinkingMessage"),
    value: z.string(),
  }),
  z.object({
    code: z.literal("ClueChangePhonePassportVisible"),
    value: z.boolean(),
  }),
  z.object({ code: z.literal("AdditionalPhoneEnabled"), value: z.boolean() }),
  z.object({ code: z.literal("RndSmev4Enabled"), value: z.boolean() }),
  z.object({ code: z.literal("OptionalScanWaitingTime"), value: z.number() }),
  z.object({ code: z.literal("PreScoringResultWaitTime"), value: z.number() }),
  z.object({
    code: z.literal("PreScoringResultWaitTimeNewClient"),
    value: z.number(),
  }),
  z.object({ code: z.literal("BINCardCheck"), value: z.boolean() }),
  z.object({
    code: z.literal("DeemFraudulentReportStartHour"),
    value: z.number(),
  }),
  z.object({ code: z.literal("EsiaDataUpdateFailureText"), value: z.string() }),
  z.object({
    code: z.literal("ShowAdditionalIncomeNewClient"),
    value: z.boolean(),
  }),
  z.object({ code: z.literal("HeaderNumberNewLK"), value: z.string() }),
  z.object({ code: z.literal("ShowAdditionalIncome"), value: z.boolean() }),
  z.object({
    code: z.literal("ChangeNumberCycleLimitCountNewLK"),
    value: z.number(),
  }),
  z.object({
    code: z.literal("ChangeNumberDataLimitCountNewLK"),
    value: z.number(),
  }),
  z.object({ code: z.literal("PFRUpridValidityPeriod"), value: z.number() }),
  z.object({
    code: z.literal("CreditLimitContractShortText"),
    value: z.string(),
  }),
  z.object({
    code: z.literal("ChangeNumberCaptchaLimitCountNewLK"),
    value: z.number(),
  }),
  z.object({ code: z.literal("ChangePhoneNewLK"), value: z.string() }),
  z.object({ code: z.literal("ApplicationPendingMessage"), value: z.string() }),
  z.object({ code: z.literal("CheckboxSOPD"), value: z.boolean() }),
  z.object({ code: z.literal("AdjustmentOfIncomeAmount"), value: z.boolean() }),
  z.object({ code: z.literal("GoogleReCaptchaSiteKey_v3"), value: z.string() }),
  z.object({ code: z.literal("GoogleReCaptchaSiteKey_v2"), value: z.string() }),
  z.object({ code: z.literal("GreaterOfferOnAppText"), value: z.string() }),
  z.object({ code: z.literal("ZeroIncomeCB"), value: z.boolean() }),
  z.object({ code: z.literal("ShowOfferChangedText"), value: z.boolean() }),
  z.object({ code: z.literal("TimerForLoadersEnabled"), value: z.boolean() }),
  z.object({
    code: z.literal("ShowRevocationBKIAgreementOnSignForm"),
    value: z.boolean(),
  }),
  z.object({
    code: z.literal("ShowTranshDetailsLinkOnSigningPage"),
    value: z.boolean(),
  }),
  z.object({
    code: z.literal("RevocationBKIAgreementText"),
    value: z.string(),
  }),
  z.object({
    code: z.literal("MakeClientExpensesPerYear"),
    value: z.boolean(),
  }),
] as const;

const SettingsItemSchema = z.discriminatedUnion("code", [
  ...SETTINGS_ITEM_OPTIONS,
]);

type SettingsItem = z.infer<typeof SettingsItemSchema>;
type SettingsCode = SettingsItem["code"];

const SETTINGS_CODES: SettingsCode[] = SETTINGS_ITEM_OPTIONS.map(
  // eslint-disable-next-line no-underscore-dangle
  (option) => option.shape.code._def.value
);

const SettingsDataSchema = z
  .array(z.object({ code: z.string(), value: z.unknown() }))
  .superRefine((items, ctx) => {
    const missingCodes = SETTINGS_CODES.filter(
      (code) => !items.some((item) => item.code === code)
    );

    if (missingCodes.length > 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Missing settings: ${missingCodes.join(", ")}`,
      });
    }
    const expectedCodes = new Set<SettingsCode>(SETTINGS_CODES);

    items.forEach((item, index) => {
      if (!expectedCodes.has(item.code as SettingsCode)) {
        return;
      }

      const parsed = SettingsItemSchema.safeParse(item);

      if (!parsed.success) {
        parsed.error.issues.forEach((issue) => {
          ctx.addIssue({
            ...issue,
            path: [item.code, ...(issue.path ?? [])],
          });
        });
      }
    });
  }) as z.ZodType<SettingsItem[]>;

export const SettingsResponseSchema = createCommonApiResponseSchema(
  z.object({
    data: SettingsDataSchema,
  })
);
